<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>{{title}}</v-card-title>

        <v-card-text>

            <m-autocomplete-phone-number
                label="Phone Number"
                v-model="endpoint"
                v-if="is_spam"
            />

            <v-text-field
                label="Phone Number"
                :value="$rc.pretty(endpoint,'endpoint')"
                readonly
                v-if="!is_spam"
                autocomplete="off"
            />

            <v-textarea
                label="Notes"
                v-model="notes"
                :rows="1"
                auto-grow
                autofocus
            />  

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="endpoint == null"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            is_spam: false,
            endpoint: null,
            notes: null,
        }
    },

    methods: {

        showDialog(is_spam, endpoint)
        {
            this.is_spam = is_spam;
            this.endpoint = endpoint;
            this.notes = null;
            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;

            this.$rc.showSpinner();

            let data =  {
                    'organization_id' : this.$route.params.organization_id,
                    'endpoint' : this.is_spam ? this.endpoint.value : this.endpoint,
                    'designated_as_spam' : this.is_spam,
                    'change_made_by_employee_id' : this.$rc.$state.employee_id,
                    'notes' : this.notes
                };

            this.$rc.rest(
                'PUT: /api/v1/spam/endpoints',
            
               data,
            
                (data) => {
                    this.$rc.hideSpinner();

                    if ( data.success == false )
                    {
                        this.$rc.alert("Unable to block number", "Unable to block number, because this is a RedChirp number");
                        return;
                    }

                    if ( !this.is_spam )
                        this.$rc.snackbar("Unblocked phone number");
                    else
                        this.$rc.snackbar("Blocked phone number");

                    this.$emit('ok');
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to block / unblock number');
                },
            );
        },

        onCancel()
        {
            this.dialog = false;
        },

    },

    computed: {
        title() {
            if ( this.is_spam )
                return "Block Number as Spam";
            
            return "Unblock Number";
        }
    },
}
</script>

<style lang="scss" scoped>
</style>